import {createAction, props} from "@ngrx/store";
import {CognitoUser} from "./cognito-user.model";

export const updateCognitoUser = createAction(
  '[Update CognitoUser] CognitoUser',
  props<{cognito:CognitoUser}>()
);
